import {
  getToken,
  setToken,
  getUSERINFO,
  setUSERINFO,
  setUserAliyun,
  getUserAliyun,
  getSYSTEMINFO,
  setSYSTEMINFO,
} from "../cookies";
import store from '@/store'
import { login, PostToken, thirdLogin, PostTokenAuto } from "@/api/loginApi";
import { handleRoute, handleButtton } from "@/utils/util";
import { routes } from "@/router";
import Layout from "@/views/index/layout/index.vue";
import BigScreen from "@/BigScreen.vue";

const safeLocalStorage = {
    get(key, defaultValue = null) {
        try {
            const data = localStorage.getItem(key);
            if (data === null || data === 'undefined' || data === 'null') {
                return defaultValue;
            }
            return JSON.parse(data);
        } catch (e) {
            console.warn(`解析 localStorage[${key}] 失败:`, e);
            return defaultValue;
        }
    },
    
    set(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.warn(`存储到 localStorage[${key}] 失败:`, e);
        }
    }
};
// 菜单模块状态库
const state = {
  // 是否收起菜单
  isCollapse: JSON.parse(localStorage.getItem("isCollapse")) || false,
  // token 令牌
  Token: getToken() || "",
  // 用户信息
  USERINFO: getUSERINFO() || {},
  // 后台返回的路由
  ArrJurisdiction: safeLocalStorage.get('ArrJurisdiction',[]),
  // 默认路由
  DEFAUTROUTERS: routes,
  // 追加的路由
  ASYNCROUTERS: [],
  // 所有的路由
  ALLROUTERS: [],
  // 按钮权限 拥有那些按钮
  BUTTONS: safeLocalStorage.get('BUTTONS',[]),
  // 阿里云信息
  USERALIYUN: getUserAliyun() || {},
  // 系统信息
  SYSTEMINFO: getSYSTEMINFO() || {},
};

const getters = {
  getIsCollapse: (state) => state.isCollapse,
  getToken: (state) => state.Token,
  getUSERINFO: (state) => state.USERINFO,
  getSYSTEMINFO: (state) => state.SYSTEMINFO,
  getUserAliyun: (state) => state.USERALIYUN,
  getDEFAUTROUTERS: (state) => state.DEFAUTROUTERS,
  getASYNCROUTERS: (state) => state.ASYNCROUTERS,
  getBUTTONS: (state) => state.BUTTONS,
  getArrJurisdiction: (state) => state.ArrJurisdiction,
  getALLROUTERS: (state) => state.ALLROUTERS,
};

const mutations = {
  setIsCollapse(state, isCollapse) {
    state.isCollapse = isCollapse;
    localStorage.setItem("isCollapse", JSON.stringify(state.isCollapse));
  },
  setToken(state, Token) {
    state.Token = Token;
  },
  setUSERINFO(state, USERINFO) {
    state.USERINFO = USERINFO;
  },
  setSYSTEMINFO(state, SYSTEMINFO) {
    state.SYSTEMINFO = SYSTEMINFO;
  },
  setUserAliyun(state, USERALIYUN) {
    state.USERALIYUN = USERALIYUN;
  },
  removeUSERINFO(state) {
    state.USERINFO = {};
  },
  removeSYSTEMINFO(state) {
    state.SYSTEMINFO = {};
  },
  removeToken(state) {
    state.Token = "";
  },
  setROUTERS(state, ASYNCROUTERS) {
    state.ASYNCROUTERS = ASYNCROUTERS;
    state.ALLROUTERS = state.DEFAUTROUTERS.concat(state.ASYNCROUTERS);
  },
  setBUTTONS(state, BUTTONS) {
    state.BUTTONS = BUTTONS;
    // localStorage.setItem("BUTTONS", JSON.stringify(BUTTONS));
    safeLocalStorage.set('BUTTONS',BUTTONS)
  },
  removeBUTTONS(state) {
    state.BUTTONS = [];
    // localStorage.setItem("BUTTONS", JSON.stringify([]));
    safeLocalStorage.set('BUTTONS',[])
  },
  setArrJurisdiction(state, ArrJurisdiction) {
    state.ArrJurisdiction = ArrJurisdiction;
    // localStorage.setItem("ArrJurisdiction", JSON.stringify(ArrJurisdiction));
    safeLocalStorage.set('ArrJurisdiction',ArrJurisdiction)
  },
  removeArrJurisdiction(state) {
    state.ArrJurisdiction = [];
    localStorage.removeItem("ArrJurisdiction");
  },
  removeASYNCROUTERS(state) {
    state.ASYNCROUTERS = [];
  },
  removeALLROUTERS(state) {
    state.ALLROUTERS = [];
  },
};

const actions = {

  /**
   * 根据地址栏信息登录
   * @param {*} param0
   * @param {*} reqData
   */
  loginStoreByUrl({ commit, dispatch }, reqData) {
    return new Promise((resolve, reject) => {
      PostTokenAuto(reqData)
        .then((resToken) => {
          // console.log("res===",resToken)
          commit("setToken", resToken.data.data.accessToken);
          setToken(resToken.data.data.accessToken);

          store.dispatch('clearProjectSelectListCache')

          setUSERINFO(JSON.stringify(resToken.data.data.userDetail));
          commit("setUSERINFO", JSON.stringify(resToken.data.data.userDetail));

          setSYSTEMINFO(JSON.stringify(resToken.data.data.systemLogInfo));
          commit("setSYSTEMINFO", JSON.stringify(resToken.data.data.systemLogInfo));

          setUserAliyun(JSON.stringify(resToken.data.data.userAliyun));
          commit("setUserAliyun", JSON.stringify(resToken.data.data.userAliyun));

          commit("setArrJurisdiction", resToken.data.data.functionList);
          resolve(resToken.data.data.functionList[0].functionId);

        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  /**
   * 登录获取基本需要信息
   * res.data.token_type
   * res.data.refresh_token
   * res.data.expires_in
   * res.data.scope
   * @param {*} param0
   * @param {*} reqData
   */
  loginStore({ commit, dispatch }, reqData) {
    return new Promise((resolve, reject) => {
      PostToken(reqData)
        .then((resToken) => {
          commit("setToken", resToken.data.access_token);
          setToken(resToken.data.access_token);

          login(reqData)
            .then((res) => {
              if (res.data.info && res.data.info.needVerifyPhone) {
                return reject(res);
              }
              if (res.data.code !== "0000") {
                return reject(res);
              }
              if (res.data.info.functionList.length === 0) {
                return reject(res);
              }
              store.dispatch('clearProjectSelectListCache')
              const data = res.data.info;
              setUSERINFO(JSON.stringify(data.userDetail));
              commit("setUSERINFO", JSON.stringify(data.userDetail));

              setSYSTEMINFO(JSON.stringify(data.systemLogInfo));
              commit("setSYSTEMINFO", JSON.stringify(data.systemLogInfo));

              setUserAliyun(JSON.stringify(data.userAliyun));
              commit("setUserAliyun", JSON.stringify(data.userAliyun));

              commit("setArrJurisdiction", data.functionList);
              // resolve(data[0].functionId)
              resolve(data.functionList[0].functionId);
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  thirdLoginStore({ commit, dispatch }, message) {
    return new Promise((resolve, reject) => {
      const data = {
        appkey: message.appkey,
        timestamp: message.timestamp,
        token: message.token,
      };
      thirdLogin(data)
        .then((res) => {
          commit("setToken", res.data.token.access_token);
          setToken(res.data.token.access_token);
          const data = res.data;
          setUSERINFO(JSON.stringify(data.userDetail));
          commit("setUSERINFO", JSON.stringify(data.userDetail));

          setSYSTEMINFO(JSON.stringify(data.systemLogInfo));
          commit("setSYSTEMINFO", JSON.stringify(data.systemLogInfo));

          setUserAliyun(JSON.stringify(data.userAliyun));
          commit("setUserAliyun", JSON.stringify(data.userAliyun));

          commit("setArrJurisdiction", data.functionList);

          // route.push("/BigScreen_8")
          resolve();
        })
        .catch((err) => {
          console.log("errrrrrrrr");
          reject(err);
        });
    });
  },
  dynamicAddRouter({ commit, state }, ArrJurisdiction) {
    return new Promise((resolve, reject) => {
      let buttons = [];
      handleButtton(ArrJurisdiction, buttons);
      buttons = buttons.map((item) => {
        return item.functionId;
      });

      commit("setBUTTONS", buttons);

      let array = [];
      ArrJurisdiction.forEach((route) => {
        let data = handleRoute(route, true);
        if (route.functionId != "Wechat_permission") {
          // if (route.functionId == "BigScreen") {
          //   data.component = BigScreen;
          // } else {
            data.component = Layout;
          // }
          array.push(data);
        }
      });

      commit("setROUTERS", array);

      // // 所有菜单
      // const joint = []
      // const buttons = []
      // for (let i = 0; i < ArrJurisdiction.length; i++) {
      //     if (ArrJurisdiction[i].functionId === 'Wechat_permission') {
      //         continue
      //     }
      //     const asyncRoutersModule = {}
      //     asyncRoutersModule['path'] = `/${ArrJurisdiction[i].functionId}`
      //     asyncRoutersModule['name'] = `${ArrJurisdiction[i].functionId}Page`
      //     asyncRoutersModule['meta'] = {}
      //     asyncRoutersModule.meta['name'] = ArrJurisdiction[i].functionName
      //     asyncRoutersModule.meta['icon'] = ArrJurisdiction[i].functionIcon
      //     if (ArrJurisdiction[i].functionId === 'BigScreen') {
      //         asyncRoutersModule['component'] = BigScreen
      //     } else {
      //         asyncRoutersModule['component'] = Layout
      //     }
      //     asyncRoutersModule['children'] = []

      //     for (let j = 0; j < ArrJurisdiction[i].children.length; j++) {
      //         let type = ArrJurisdiction[i].children[j].type
      //         if (type == 'page') {
      //             const asyncRouterPagesModule = {}
      //             asyncRouterPagesModule['path'] = `/${ArrJurisdiction[i].children[j].functionId}`
      //             asyncRouterPagesModule['name'] = `${ArrJurisdiction[i].children[j].functionId}Page`
      //             if (ArrJurisdiction[i].children[j].status === '1') {
      //                 asyncRouterPagesModule['hidden'] = true
      //             }
      //             asyncRouterPagesModule['meta'] = {}
      //             asyncRouterPagesModule.meta['name'] = ArrJurisdiction[i].children[j].functionName
      //             asyncRouterPagesModule.meta['icon'] = ArrJurisdiction[i].children[j].functionIcon
      //             const component = resolve => require([`@/views/${ArrJurisdiction[i].children[j].path}`], resolve)
      //             asyncRouterPagesModule['component'] = component
      //             asyncRoutersModule.children.push(asyncRouterPagesModule)
      //             const btnTemp = ArrJurisdiction[i].children[j].children.filter(item => {
      //                 return item.functionId
      //             })
      //             btnTemp.forEach(item => {
      //                 buttons.push(item.functionId)
      //             })
      //         } else {
      //             buttons.push(ArrJurisdiction[i].children[j].functionId)
      //         }
      //     }

      //     if (asyncRoutersModule.children.length == 0) {
      //         const asyncRouterPagesModule = {}
      //         asyncRouterPagesModule['path'] = `/${ArrJurisdiction[i].functionId}`
      //         asyncRouterPagesModule['name'] = `${ArrJurisdiction[i].functionId}Page`
      //         if (ArrJurisdiction[i].status === '1') {
      //             asyncRouterPagesModule['hidden'] = true
      //         }
      //         asyncRoutersModule['single'] = true
      //         asyncRouterPagesModule['meta'] = {}
      //         asyncRouterPagesModule.meta['name'] = ArrJurisdiction[i].functionName
      //         asyncRouterPagesModule.meta['icon'] = ArrJurisdiction[i].functionIcon
      //         const component = resolve => require([`@/views/${ArrJurisdiction[i].path}`], resolve)
      //         asyncRouterPagesModule['component'] = component
      //         asyncRoutersModule.children.push(asyncRouterPagesModule)
      //     }

      //     joint.push(asyncRoutersModule)
      // }
      // joint.forEach(item => {
      //     if (item.children.length > 1) {
      //         const keepData = ['监控管理', '故障列表', '上下线记录', '波形图', '设备升级', 'Log调试信息', '校验电梯', '故障视频']
      //         item.children.forEach(v => {
      //             if (keepData.indexOf(v.meta.name) !== -1) {
      //                 v.meta.keepAlive = true
      //             } else {
      //                 v.meta.keepAlive = false
      //             }
      //         })
      //     } else {
      //         item.meta.keepAlive = false
      //     }
      // })
      // commit('setBUTTONS', buttons)
      // commit('setROUTERS', joint)
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
